import { render } from "./TestUCInformationWithoutSearchRecord.vue?vue&type=template&id=7ff3f054"
import script from "./TestUCInformationWithoutSearchRecord.vue?vue&type=script&lang=js"
export * from "./TestUCInformationWithoutSearchRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__